module.exports = __webpack_public_path__ + "media/images/city/030-pula-arena-9f16aa911945f56e917b4c24a9c7fad7.svg";